module.exports = __webpack_public_path__ + "static/media/produkt-fallback.26d1b89b.svg";